<template>
  <NavigationSecondary />
  <router-view v-slot="{Component}">
    <!-- <keep-alive> is needed here AND in App.vue -->
    <!-- :key must be on <component>, not on keep-alive -->
    <!-- the sidebar's hashes (#faq…) keep the page: its panels switch inside it -->
    <keep-alive>
      <component :is="Component" :key="getPageKey($route)" />
    </keep-alive>
  </router-view>
</template>

<script setup>
import {computed, onActivated, onDeactivated, onUnmounted, watch} from "vue";
import NavigationSecondary from "@/components/Navigation/Secondary.vue";
import {useDisplayWidth} from "@/composables/useDisplayWidth";
import {setPinnedTop, usePinnedTop} from "@/composables/usePinnedTop";
import {getIsSidebarHash} from "@/composables/useYearSidebar";
// the page's key: its address, less the sidebar's state, all in the hash (YearSidebar/;
// 2026-10-22: an automatic Highlights step would otherwise rebuild the page)
const getPageKey = (route) => {
  const isSidebarHash = getIsSidebarHash(route.hash);
  return `year${isSidebarHash ? route.fullPath.replace(route.hash, "") : route.fullPath}`;
};
// on a phone (the compact header: title and menu button), every page of a year keeps its top
// pinned as the content scrolls: banner, header, the year's menu (and a sidebar's control, on a
// page with one) (usePinnedTop.js; Seán, 2026-10-22). Only while a year's page shows (kept
// alive: off when left)
const width = useDisplayWidth();
const isPinned = computed(() => width.value === "narrow");
watch(isPinned, setPinnedTop, {immediate: true});
onActivated(() => setPinnedTop(isPinned.value));
onDeactivated(() => setPinnedTop(false));
onUnmounted(() => setPinnedTop(false));
usePinnedTop();
</script>
